// extracted by mini-css-extract-plugin
export default {"infoContainer":"InfoComponent-module__infoContainer___QLYZV","infoButton":"InfoComponent-module__infoButton___yjemo"};